import { Component, OnInit, Input, Output } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'confirm-modal-template',
  templateUrl: './confirm-modal-template.component.html',
  styleUrls: ['./confirm-modal-template.component.scss']
})
export class ConfirmModalTemplateComponent implements OnInit {

  @Input() title: any;
  @Input() messaggio: any;
  private response = new BehaviorSubject<boolean>(null);

  constructor(protected ref: NbDialogRef<ConfirmModalTemplateComponent>) { }

  ngOnInit() {
  }

  dismiss() {
    this.response.next(false);
    this.ref.close();
  }

  confirm() {
    this.response.next(true);
    this.ref.close();
  }

  isConfirmed():any {
    return this.response.asObservable();
  }

}
